import { Routes } from "../../methods/ApiRoutes";

const shared = {
    title: 'Settings',
    addTitle: ' Settings',
    url: 'settings',
    ...Routes.settings
};

export default shared;
